export default __webpack_public_path__ + "static/media/404.b6d5862a.png";